export enum StornoStateEnum {
    None,
    Waiting,
    Storno
}